import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4cf4b994")

_pushScopeId("data-v-4cf4b994")
const _hoisted_1 = {
  key: 0,
  class: "p-card",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "p-grid p-m-0" }
const _hoisted_3 = { class: "p-col-7 p-pr-0" }
const _hoisted_4 = { class: "chart-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "p-col-5 p-text-right p-pl-0 p-pr-3 p-ml-auto" }
const _hoisted_9 = {
  key: 1,
  class: "p-card"
}
const _hoisted_10 = { class: "chart-empty p-text-center" }
const _hoisted_11 = { class: "chart-empty-title p-text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_ctx.data.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(_ctx.title), 1),
              _hoisted_5,
              (_ctx.experimentStatus == 1)
                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.testScore), 1))
                : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.valScore), 1))
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedModel,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedModel = $event)),
              options: _ctx.listModels
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_v_chart, {
          class: "chart",
          option: _ctx.option,
          theme: _ctx.theme,
          autoresize: ""
        }, null, 8, ["option", "theme"])
      ]))
    : (_ctx.experimentStatus > -1)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_ProgressSpinner, {
              class: "p-d-flex p-jc-between p-ai-center",
              style: {"height":"100%"}
            })
          ]),
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("automl.evaluation.chart.training")), 1)
        ]))
      : _createCommentVNode("", true)
})